<template>
    <div class="">
        <template v-if="isPageAllowed">
            <div class="filter-bar mb20">
                <el-form :inline="true" @submit.native.prevent="submitSearch" @keyup.enter.native="submitSearch">
                    <el-form-item label="成员：">
                        <el-input v-model.trim="tempQuery.user_name" clearable placeholder="输入成员姓名、手机号、邮箱搜索" style="width: 365px;">
                            <el-button slot="append" icon="el-icon-search" @click="submitSearch"></el-button>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="角色：">
                        <el-input v-model.trim="tempQuery.search" clearable placeholder="根据角色名称关键字进行搜索" style="width: 250px;">
                            <el-button slot="append" icon="el-icon-search" @click="submitSearch"></el-button>
                        </el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div class="tool-bar mb20">
                <el-button type="primary" class="ml20" v-if="pageFuncNames.includes('add_role')" @click="showAddPage">添加角色</el-button>
                <el-button type="primary" class="ml20" v-if="pageFuncNames.includes('order_config')" @click="showSortModal">排序配置</el-button>

                <div v-if="is_super_admin" class="ml40 inline-block">
                    <el-button type="primary" :disabled="roleSelected.length<=0" @click="handleCommand('batchAdd')" plain>批量增加权限</el-button>
                    <el-button type="primary" :disabled="roleSelected.length<=0" @click="handleCommand('batchRemove')" plain>批量去除权限</el-button>
                </div>
            </div>

            <!--:default-sort = "{prop: 'ctime', order: 'descending'}"-->
            <!--@sort-change="handleSortChange"-->
            <jt-table
                :data="dataList"
                stripe
                :header-cell-style="{background:'#e8eaec',color:'#333'}"
                @selection-change="selectionChange"
                style="width:100%;"
                v-loading="dataLoading"
                class="table-fixed"
                ref="table"
            >
                <el-table-column
                    fixed
                    type="selection"
                    align="center"
                    width="60">
                </el-table-column>
                <el-table-column
                    v-if="pageFieldsNames.includes('role_name')"
                    width="150px"
                    property="role_name"
                    label="角色名称">
                    <template slot-scope="scope">
                        <span>{{scope.row.role_name||'--'}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    property="action"
                    label="操作"
                    width="220px"
                    align="center">
                    <template slot-scope="scope">
                        <el-link v-if="pageFuncNames.includes('edit_role')" type="primary" class="ml6 mr6" :disabled="userRoleIds.includes(scope.row.role_id)" @click="editRole(scope.row)">编辑</el-link>
                        <el-link v-if="pageFuncNames.includes('get_role')" type="primary" class="ml6 mr6" @click="viewRole(scope.row)">查看</el-link>
                        <el-link v-if="pageFuncNames.includes('copy_role')" type="primary" class="ml6 mr6" @click="copyRole(scope.row)">复制</el-link>
                        <el-link v-if="pageFuncNames.includes('delete_role')" type="danger" class="ml6 mr6" @click="deleteRole(scope.row)">删除</el-link>
                    </template>
                </el-table-column>
                <el-table-column
                    v-if="pageFieldsNames.includes('role_type')"
                    align="center"
                    width="120px"
                    property="role_type"
                    label="角色类型">
                    <template slot-scope="scope">
                        <span>{{scope.row.role_type||'--'}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    v-if="pageFieldsNames.includes('note')"
                    show-overflow-tooltip
                    property="note"
                    label="角色说明">
                    <template slot-scope="scope">
                        <span>{{scope.row.note||'--'}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    v-if="pageFieldsNames.includes('use_num')"
                    align="center"
                    property="use_num"
                    label="使用成员">
                    <template slot-scope="scope">
                        <el-link v-if="scope.row.use_num>0" type="primary" :underline="false" @click="toDepartmentPage(scope.row)">
                            {{scope.row.use_num}}
                        </el-link>
                        <span v-else>{{scope.row.use_num}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    v-if="pageFieldsNames.includes('mtime')"
                    align="center"
                    width="150px"
                    property="mtime"
                    label="编辑时间">
                    <template slot-scope="scope">
                        <span>{{scope.row.mtime||'--'}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    v-if="pageFieldsNames.includes('editor')"
                    align="center"
                    property="editor"
                    label="编辑人">
                    <template slot-scope="scope">
                        <span>{{scope.row.editor||'--'}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    v-if="pageFieldsNames.includes('ctime')"
                    align="center"
                    width="150px"
                    property="ctime"
                    key="ctime"
                    label="创建时间">
                    <template slot-scope="scope">
                        <span>{{scope.row.ctime||'--'}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    v-if="pageFieldsNames.includes('creator')"
                    align="center"
                    property="creator"
                    label="创建人">
                    <template slot-scope="scope">
                        <span>{{scope.row.creator||'--'}}</span>
                    </template>
                </el-table-column>
            </jt-table>
            <div class="page-bar tac mt20">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="queryData.pn"
                    :page-size="queryData.rn"
                    :page-sizes="[30,50,100]"
                    :pager-count="5"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalCnt">
                </el-pagination>
            </div>
            <SortModal ref="sortModal" @update="getDataList" />
        </template>
        <template v-else>
            <NoPermissionInfo>
                <p>此页面展示系统所有角色，并且可对角色进行维护与添加。</p>
            </NoPermissionInfo>
        </template>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import API from '@/api/role.js';
    import {pageMixin} from '../../mixins/pageMixin';
    import NoPermissionInfo from '@/components/noPermissionInfo';
    import SortModal from '../modal/roleSortModal';

    export default {
        name: "RoleList",
        mixins: [pageMixin],
        components:{
            NoPermissionInfo,
            SortModal,
        },
        data() {
            return {
                dataLoading: true,
                tempQuery: {
                    search: '',
                    user_name:'',
                },
                queryData: {
                    user_name:'',
                    search: '',
                    pn: 1,
                    rn: 30,
                    // order_by:'ctime',
                    // order_type:'desc',
                },
                totalCnt: 0,
                dataList: [],
                userRoleIds:[],     //不可编辑的角色id
                /* 为了解决默认排序显示问题，需配合列表的key使用 */
                pageFields:[{
                    name:'ctime'
                }],
                roleSelected:[],
            }
        },
        computed: {
            ...mapGetters(['confirm_route','is_super_admin'])
        },
        created() {
            let routeParams = this.$route.params || {};
            let original = JSON.parse(routeParams.original||'{}');

            this.queryData.pn =original.pn||this.queryData.pn;
            this.queryData.rn =original.rn||this.queryData.rn;
            this.queryData.search =original.search||this.queryData.search;
            this.tempQuery.search =original.search||this.queryData.search;

            this.queryData.user_name =original.user_name||this.queryData.user_name;
            this.tempQuery.user_name =original.user_name||this.queryData.user_name;
            console.log('created routeQuery',original);
            this.getDataList();
        },
        methods: {
            toConfigPage(id,type) {
                this.$emit('togglePage');
                this.$router.replace({
                    name: 'role_management',
                    query: {
                        action: 'config',
                        t: +new Date(),
                        role_id:id,
                        type:type,
                    },
                    params:{
                        original:JSON.stringify(this.queryData),
                    }
                })
            },
            showSortModal(){
                this.$refs.sortModal.showModal();
            },
            showAddPage() {
                this.toConfigPage('','add');
            },
            handleSizeChange(val) {
                this.queryData.rn= val;
                this.getDataList();
            },
            handleCurrentChange(val) {
                this.queryData.pn= val;
                this.getDataList();
            },
            getDataList() {
                this.dataLoading = true;
                this.roleSelected = [];
                API.getRoleList({
                    search: this.queryData.search,
                    user_name: this.queryData.user_name,
                    // order_by:this.queryData.order_by,
                    // order_type:this.queryData.order_type,
                    pn: this.queryData.pn,
                    rn: this.queryData.rn,
                }).then(res => {
                    let resData = res.data || {};
                    this.dataLoading = false;
                    this.dataList = resData.list;
                    this.totalCnt = resData.totalCnt;
                    this.userRoleIds = resData.user_use_role_ids||[];

                    this.$nextTick(()=>{
                        this.$refs.table.doLayout();
                    });
                }, (err) => {
                    console.log('getUserList error', err);
                    this.dataList = [];
                    this.dataLoading = false;
                    this.totalCnt = 0;
                });
            },
            submitSearch() {
                this.queryData.pn = 1;
                this.queryData.search = this.tempQuery.search;
                this.queryData.user_name = this.tempQuery.user_name;
                this.getDataList();
            },
            toDepartmentPage(row) {
                this.$router.push({
                    name:'organization_management',
                    params: {
                        role_id: row.role_id,
                    },
                });
            },
            deleteRole(row){
                this.$confirm('是否确定删除该角色？删除后不可恢复！', '警告', {
                    closeOnPressEscape:false,
                    confirmButtonText: '删除',
                    cancelButtonText: '取消',
                    confirmButtonClass: 'danger-btn',
                    type: 'warning',

                }).then(() => {
                    API.deleteRole({
                        role_id:row.role_id,
                    }).then(res => {
                        this.$message.success(res.info||'操作成功');
                        this.getDataList();
                    }, (err) => {
                        console.log('deleteRole error', err);
                        this.$message.error(err.info||'操作失败');
                    });
                }).catch(() => {
                    console.log('cancel')
                });
            },
            editRole(row){
                this.toConfigPage(row.role_id,'edit');
            },
            viewRole(row){
                this.toConfigPage(row.role_id,'view');
            },
            copyRole(row){
                this.toConfigPage(row.role_id,'copy');
            },
            // handleSortChange(column){
            //     this.queryData.order_type = column.order=='descending'?'desc':'asc';
            //     this.queryData.order_by = column.prop;
            //     this.submitSearch();
            // },
            handleCommand(command){
                return this.$message.error('功能升级中，敬请期待...');
                this.$emit('batch',command,this.roleSelected);
                this.$router.replace({
                    name: 'role_management',
                    query: {
                        action: command,
                        t: +new Date(),
                    },
                    params:{
                        original:JSON.stringify(this.queryData),
                    }
                });
            },
            selectionChange(val){
                this.roleSelected = val.map(item => item);
            }
        },
        mounted() {
            // console.log(1, 'list.mounted');
        },
        destroyed() {
            // console.log(1, 'list.destroyed');
        }
    }
</script>

<style lang="scss" scoped>
    .filter-bar{
        background-color: #f8f8f9;
        padding: 20px 20px 0;
        border-radius: 5px;
    }
    .table-fixed{
        ::v-deep .el-table__fixed{
            height: 100% !important;
        }
    }
</style>
